export const PersonIcon = () => {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2446_12389)">
        <path
          d="M9 10.5C10.3261 10.5 11.5979 9.97322 12.5355 9.03553C13.4732 8.09785 14 6.82608 14 5.5C14 4.17392 13.4732 2.90215 12.5355 1.96447C11.5979 1.02678 10.3261 0.5 9 0.5C7.67392 0.5 6.40215 1.02678 5.46447 1.96447C4.52678 2.90215 4 4.17392 4 5.5C4 6.82608 4.52678 8.09785 5.46447 9.03553C6.40215 9.97322 7.67392 10.5 9 10.5ZM7.21484 12.375C3.36719 12.375 0.25 15.4922 0.25 19.3398C0.25 19.9805 0.769531 20.5 1.41016 20.5H16.5898C17.2305 20.5 17.75 19.9805 17.75 19.3398C17.75 15.4922 14.6328 12.375 10.7852 12.375H7.21484Z"
          fill="#6D28D9"
        />
      </g>
      <defs>
        <clipPath id="clip0_2446_12389">
          <path d="M0.25 0.5H17.75V20.5H0.25V0.5Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
